import { Grid } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { GroupInfo } from "generated/CoreApi_v1";
import { useState } from "react";
import { AudienceSelector } from "views/foundation/group/components/AudienceSelector";
import { IAdvFilterPickerProps, IAdvFilterResult } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////////

export const AudiencePicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;

    const [selected, setSelected] = useState<GroupInfo | null>(null);

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected != null) {
            const newFilter: IAdvFilterResult = {
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${selected.name}`,
                value: selected.id,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            };
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <AudienceSelector
                    onChange={(value) => setSelected(value ?? null)}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected == null}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
